import React from 'react';
import { CHILDREN_COMPONENT, INHERITED_NAME } from "./core/index.mjs";
import getOriginChildren from "./getOriginChildren.mjs";
function findComponent(Children, names, recursively) {
  var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 100;
  var children = Children[CHILDREN_COMPONENT] ? getOriginChildren(Children) : Children;
  return React.Children.toArray(children).find(function (child) {
    if ( /*#__PURE__*/React.isValidElement(child)) {
      if (child.type === React.Fragment) {
        return findComponent(child.props.children, names, recursively, limit);
      }
      // @ts-ignore
      var inheritedNames = child.type[INHERITED_NAME] || [child.type.displayName];
      var result = !!inheritedNames.find(function (name) {
        return names.includes(name);
      });
      if (!result && child.props.children && recursively && limit > 0) {
        return findComponent(child.props.children, names, recursively, limit - 1);
      }
      return result;
    }
  });
}
export function isAdvanceMode(Children, name, recursively) {
  var children = Children[CHILDREN_COMPONENT] ? getOriginChildren(Children) : Children;
  if (!children) return false;
  if (typeof children === 'function') {
    return true;
  }
  return !!findComponent(children, name, recursively);
}
export function findAllComponents(Children, names) {
  var result = [];
  var findAllAndAdd = function findAllAndAdd(Children) {
    var children = Children[CHILDREN_COMPONENT] ? getOriginChildren(Children) : Children;
    React.Children.toArray(children).forEach(function (child) {
      if ( /*#__PURE__*/React.isValidElement(child)) {
        if (child.type === React.Fragment) {
          findAllAndAdd(child.props.children);
        } else {
          // @ts-ignore
          var inheritedNames = child.type[INHERITED_NAME] || [child.type.displayName];
          var component = !!inheritedNames.find(function (name) {
            return names.includes(name);
          });
          if (component) {
            result.push(child);
          }
          if (child.props.children) {
            return findAllAndAdd(child.props.children);
          }
        }
      }
    });
  };
  findAllAndAdd(Children);
  return result;
}
export default findComponent;
//# sourceMappingURL=findComponent.mjs.map